"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.removeSnowplowTrackerReadyEventListener = exports.dispatchSnowplowTrackerReadyEvent = exports.dispatchSnowplowTrackerNotReadyEvent = exports.addSnowplowTrackerReadyEventListener = void 0;
var SNOWPLOW_TRACKER_READY_EVENT = 'snowplowTrackerReady';
var SNOWPLOW_TRACKER_NOT_READY_EVENT = 'snowplowTrackerNotReady';
var addSnowplowTrackerReadyEventListener = function addSnowplowTrackerReadyEventListener(handleEvent) {
  window.addEventListener(SNOWPLOW_TRACKER_READY_EVENT, handleEvent);
};
exports.addSnowplowTrackerReadyEventListener = addSnowplowTrackerReadyEventListener;
var dispatchSnowplowTrackerNotReadyEvent = function dispatchSnowplowTrackerNotReadyEvent() {
  var event = new Event(SNOWPLOW_TRACKER_NOT_READY_EVENT);
  window.dispatchEvent(event);
};
exports.dispatchSnowplowTrackerNotReadyEvent = dispatchSnowplowTrackerNotReadyEvent;
var dispatchSnowplowTrackerReadyEvent = function dispatchSnowplowTrackerReadyEvent() {
  var event = new Event(SNOWPLOW_TRACKER_READY_EVENT);
  window.dispatchEvent(event);
};
exports.dispatchSnowplowTrackerReadyEvent = dispatchSnowplowTrackerReadyEvent;
var removeSnowplowTrackerReadyEventListener = function removeSnowplowTrackerReadyEventListener(handleEvent) {
  window.removeEventListener(SNOWPLOW_TRACKER_READY_EVENT, handleEvent);
};
exports.removeSnowplowTrackerReadyEventListener = removeSnowplowTrackerReadyEventListener;